<template>
  <div class="page-wrap">
    <filter-component
      :initial-filters="filter"
      class="page-filters"
      @click="handleFilter"
    />
    <div class="page">
      <header class="page-header">
        <div class="title">{{ $t('flights-list') }}:</div>
      </header>
      <transition name="fade">
        <div
          v-if="!flights.length && !loading"
          key="no-results"
          class="empty-list"
        >
          {{ $t('no-results') }}
        </div>
        <div v-else-if="loading" key="loader" class="loader-wrapper">
          <loader class="loader-wrapper__element" />
        </div>
      </transition>
      <transition name="fade" mode="out-in">
        <div v-if="pageNumber && !loading" class="flights-list">
          <flight-component
            v-for="flight in flights"
            :key="flight.id"
            :flight="flight"
          />
        </div>
      </transition>
      <div v-if="flights.length && !loading" class="navigation">
        <button-component
          :class="{ hidden: pageNumber <= 1 }"
          :locked="loading"
          class="btn-pagination"
          white
          square
          @click="getPrevPage"
        >
          <div class="arrow arrow--left" />
        </button-component>
        <div class="page-number">
          <span class="page-number--current">{{ pageNumber }}</span> /
          {{ maxPages }}
        </div>
        <button-component
          :class="{ hidden: pageNumber == maxPages }"
          :locked="loading"
          class="btn-pagination"
          white
          square
          @click="getNextPage"
        >
          <div class="arrow" />
        </button-component>
      </div>
    </div>
    <modal
      v-if="showModal"
      :message="status"
      :message-time="statusTime"
      @hide-modal="showModal = false"
    />
  </div>
</template>

<script>
import ButtonComponent from '@/components/Button'
import FilterComponent from '@/components/Filter'
import FlightComponent from '@/components/Flight'
import Modal from '@/components/Modal'
import loader from '@/components/Loader'
import service from '@/service'
import { format, subDays } from 'date-fns'

export default {
  components: {
    ButtonComponent,
    FilterComponent,
    FlightComponent,
    Modal,
    loader
  },
  props: {
    status: {
      type: String,
      default: ''
    },
    statusTime: {
      type: Number,
      default: 2000
    }
  },
  data() {
    return {
      flights: [],
      loading: true,
      pageSize: 6,
      pageNumber: 1,
      maxPages: 1,
      showModal: this.status,
      filter: {
        flightDateFrom: format(subDays(new Date(), 2), 'yyyy-MM-dd'),
        flightDateTo: format(new Date(), 'yyyy-MM-dd'),
        flightNumber: ''
      }
    }
  },
  created() {
    this.filterDashboard()
  },
  methods: {
    getNextPage() {
      this.loading = true
      this.pageNumber++
      this.filterDashboard().then(() => {
        this.loading = false
      })
    },
    getPrevPage() {
      if (this.pageNumber <= 1) return
      this.loading = true
      this.pageNumber--
      this.filterDashboard().then(() => {
        this.loading = false
      })
    },
    handleFilter(filterBuffer) {
      this.filter = filterBuffer
      this.pageNumber = 1
      this.loading = true
      this.filterDashboard()
    },
    filterDashboard() {
      const params = {
        flightsIdList: [],
        searchString: this.filter.flightNumber,
        flightDateFrom: this.filter.flightDateFrom,
        flightDateTo: this.filter.flightDateTo,
        pageSize: this.pageSize,
        pageNumber: this.pageNumber
      }

      return service.flights
        .collect(params)
        .then(resp => {
          const totalRecords = resp.data.totalRecords
          this.loading = false
          this.maxPages = Math.ceil(totalRecords / this.pageSize)
          this.flights = resp.data.flights
          this.pageNumber = totalRecords ? this.pageNumber : 0
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  display: grid;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.title {
  @include main-title;
  text-align: left;
  margin: 0;
}

.flights-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.flights-list,
.empty-list,
.loader-wrapper {
  grid-column: 1;
  grid-row: 2;
}

.empty-list,
.loader-wrapper {
  display: flex;
  justify-content: center;
  margin: 50px;
}

.empty-list {
  min-height: 50px;
  align-items: center;
}

.loader-wrapper {
  &__element {
    width: 50px;
    height: 50px;
  }
}

.btn-wrap {
  max-width: 768px;
  margin: 0 auto 30px;
  display: flex;
  justify-content: flex-end;
}

.navigation {
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;

  @include media-down(md) {
    flex-direction: row;
  }
}

.btn-pagination {
  width: 70px;
  padding-top: 11px;
  padding-bottom: 11px;

  &.hidden {
    opacity: 0;
    pointer-events: none;
  }

  img {
    margin: 0;
  }

  + .btn-pagination {
    margin-left: 20px;
  }

  @include media-down(md) {
    margin: 0;

    + .btn-pagination {
      margin: 0 0 0 20px;
    }
  }
}

.page-number {
  font-size: 18px;

  &--current {
    font-weight: 500;
  }
}
</style>
